import { Spinner } from "@/components/Spinner";
import { TitleCard } from "@/components/TitleCard";
import { useResource } from "@/hooks/useResource";
import type { ProgressRow, TitleCard as TitleCardModel } from "@/api/types";

export function Watchlist() {
  const list = useResource<{ results: TitleCardModel[] }>("/api/v1/playback/watchlist");
  const resume = useResource<{ results: ProgressRow[] }>("/api/v1/playback/continue-watching");

  if (list.loading) return <Spinner />;

  return (
    <main className="page container">
      <div style={{ paddingTop: 34 }}>
        <h1>My list</h1>
        {(list.data?.results.length ?? 0) === 0 ? (
          <div className="empty">
            Nothing saved yet. Add a title from its page and it will show up here.
          </div>
        ) : (
          <div className="grid">
            {list.data?.results.map((title) => (
              <TitleCard key={title.id} title={title} />
            ))}
          </div>
        )}

        {(resume.data?.results.length ?? 0) > 0 && (
          <>
            <h2 style={{ fontSize: 20, marginTop: 24 }}>Continue watching</h2>
            <div className="grid">
              {resume.data?.results.map((row) => (
                <TitleCard
                  key={row.asset_id}
                  title={row.title}
                  progress={row.percent_complete}
                  subtitle={
                    row.episode
                      ? `S${row.episode.season_number} E${row.episode.number}`
                      : `${Math.round(row.percent_complete * 100)}% watched`
                  }
                />
              ))}
            </div>
          </>
        )}
      </div>
    </main>
  );
}
